import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  insurerDashboardTabHref,
  insurerDashboardTabItems,
  parseInsurerDashboardTab,
} from '../../utils/insurerDashboardTabs';

const InsurerDashboardTabNav: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isOrgAdmin = user?.org_role === 'org_admin';
  const activeTab = parseInsurerDashboardTab(searchParams, isOrgAdmin, location.pathname);
  const tabs = insurerDashboardTabItems(isOrgAdmin);

  if (user?.role !== 'INSURER') {
    return null;
  }

  return (
    <div className="border-t border-gray-200 bg-white">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <nav className="-mb-px flex space-x-6 overflow-x-auto" aria-label="Insurer dashboard">
          {tabs.map(({ key, label }) => {
            const href = insurerDashboardTabHref(key);
            const isActive = activeTab === key;
            return (
              <Link
                key={key}
                to={href}
                className={`whitespace-nowrap py-2 px-3 rounded-lg text-sm font-semibold transition-all ${
                  isActive
                    ? 'bg-slate-100 text-[#0c1e40] border-b-2 border-[#991b1b] shadow-sm'
                    : 'text-gray-600 hover:text-[#0c1e40] hover:bg-gray-50'
                }`}
              >
                {label}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default InsurerDashboardTabNav;
